import axios from 'axios'
import { defineStore } from 'pinia'

const errorMessage = error => error.response?.data?.message ?? 'We could not load the customer holiday schedules. Please try again.'

export const useHolidaysPublicAdminStore = defineStore('holidaysPublicAdmin', {
  state: () => ({
    items: [],
    search: '',
    pagination: {
      currentPage: 1,
      lastPage: 1,
      total: 0,
    },
    isLoading: false,
    savingIds: [],
    error: null,
  }),

  actions: {
    async fetchEntries(page = 1) {
      this.isLoading = true
      this.error = null

      try {
        const { data } = await axios.get('/api/v1/holidays-public/customer-holidays', {
          params: {
            page,
            search: this.search || undefined,
          },
        })
        this.items = data.data
        this.pagination = {
          currentPage: data.meta.current_page,
          lastPage: data.meta.last_page,
          total: data.meta.total,
        }
      } catch (error) {
        this.items = []
        this.error = errorMessage(error)
        throw error
      } finally {
        this.isLoading = false
      }
    },

    async saveHoliday(customerHolidayId, schedule) {
      this.savingIds.push(customerHolidayId)
      this.error = null

      try {
        const { data } = await axios.put(`/api/v1/holidays-public/customer-holidays/${customerHolidayId}`, schedule)
        this.patchHoliday(data.data)

        return data.data
      } catch (error) {
        this.error = errorMessage(error)
        throw error
      } finally {
        this.savingIds = this.savingIds.filter(id => id !== customerHolidayId)
      }
    },

    patchHoliday(holiday) {
      const index = this.items.findIndex(item => item.customer_holiday_id === holiday.customer_holiday_id)

      if (index >= 0) {
        this.items.splice(index, 1, holiday)
      }
    },
  },
})
